// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"489d5dd0","302":"e024b97c","487":"5c5857e9","508":"489d5dd0","713":"c6db104d","764":"b7e8f7b6","880":"489d5dd0","896":"20c3e78d"}[chunkId] + ".chunk.css";
};